export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Dividas.vue?vue&type=template&id=52620f02&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/relatorios/Dividas.vue?vue&type=template&id=52620f02&
// module id = 513
// module chunks = 1